module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_mobile1-e12fd33f67bf3a9aa561b0673c00b408.jpg";